import { defineMessages } from "react-intl";

export const messages = defineMessages({
  "messages.heading": {
    id: "messages.heading",
    defaultMessage: "Messages",
  },
  "messages.empty.title": {
    id: "messages.empty.title",
    defaultMessage: "There are no messages yet",
  },
  "messages.empty.description": {
    id: "messages.empty.description",
    defaultMessage:
      "Messages will appear here once a conversation with a coach begins.",
  },
  "messages.empty.create-btn": {
    id: "messages.empty.create-btn",
    defaultMessage: "Choose the coach",
  },
  "messages.aside.pick-coach": {
    id: "messages.aside.pick-coach",
    defaultMessage: "Pick the coach",
  },
  "messages.conversation.message.placeholder": {
    id: "messages.conversation.message.placeholder",
    defaultMessage: "Type you message...",
  },
  "messages.conversation.send": {
    id: "messages.conversation.send",
    defaultMessage: "Send",
  },
});
